import { IStyle, Stack } from '@fluentui/react';
import { Sizes, useClassNames } from '@h2oai/ui-kit';
import React from 'react';

import { stackStylesPage } from '../../themes/themes';
import { ClassNamesFromIStyles } from '../../utils/models';

interface IPageWrapperStyles {
  container: IStyle;
  stack: IStyle;
}

const pageWrapperStyles = (): Partial<IPageWrapperStyles> => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    padding: Sizes.padding,
    paddingBottom: 0,
    height: `calc(100vh - 120px)`,
    overflowY: 'auto',
  },
  stack: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    padding: Sizes.padding,
    paddingBottom: 0,
    height: '100%',
  },
});

const PageWrapper: React.FC = ({ children }) => {
  const classNames = useClassNames<IPageWrapperStyles, ClassNamesFromIStyles<IPageWrapperStyles>>(
    'pageWrapper',
    pageWrapperStyles
  );

  return (
    <div className={classNames.container}>
      <Stack styles={stackStylesPage} className={classNames.stack}>
        {children}
      </Stack>
    </div>
  );
};

export default PageWrapper;
